<template>
  <div class="mb-6">
    <!-- Label -->
    <label :for="id" class="block w-full mb-1">
      {{ label }}
      <span v-if="required" class="text-nucleus-error font-bold"> * </span>
    </label>

    <div class="relative">
      <select
        :id="id"
        :value="value"
        class="block w-full border border-nucleus-darkestBlue rounded p-2 bg-nucleus-lightestBlue color-nucleus-darkestBlue"
        @input="updateValue"
      >
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.id"
          :nameOption="option.name"
        >
          {{ option.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:value", "updateInputType"],
  props: {
    label: String,
    value: String,
    options: Array,
    required: Boolean,
    id: String,
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    // Update Model Value
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValue(event: any) {
      this.$emit("update:value", event.target.value);
    },
  },
})
export default class Select extends Vue {}
</script>
